module.exports = __webpack_public_path__ + "img/2.872e6392.png";